import app from './app';

const ActionCreators = {
  ...app,
};

export default ActionCreators;
